// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LineChart_wrapper__TYWt_"};